import cx from 'classnames'
import { screenSizes, spacing } from 'constants/global'
import { FormattedMessage } from 'locales/index'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { RouteComponentProps } from 'react-router-dom'
import { CommutifiLogo, Typography } from '@commutifi-fe/ui'
import { EnterpriseSurveyPages, EnterpriseSurveyPathsParams } from 'src/routing'
import SurveyLayout from '../layout/SurveyLayout'
import { CommutifiBenefit } from './components/CommutifiBenefit'
import { StartSurveyButtons } from './components/StartSurveyButtons'
import { SurveyLandingPageCardLayout } from './layout/SurveyLandingPageCardLayout'
import { SurveyLandingPageLayout } from './layout/SurveyLandingPageLayout'
import styles from './styles.module.scss'

const { Title, Text, ExternalLink } = Typography

function AnonymousLandingPage({ history }: RouteComponentProps) {
  const handleStartAnonymousSurvey: React.MouseEventHandler = (e) => {
    e.preventDefault()
    history.push(`${EnterpriseSurveyPages.Onboarding}/${EnterpriseSurveyPathsParams.Step}1`)
  }
  const isXSmall = useMediaQuery({ maxWidth: screenSizes.xsMaxWidth })
  const renderAlreadyHaveAnAccount = React.useCallback(
    () => (
      <div
        className={cx('u-flex-justify-start', isXSmall ? 'u-margin-top--small' : 'u-margin-vertical--medium')}
        style={{ width: '100%' }}
      >
        <Text type="secondary" size={isXSmall ? 'small' : 'regular'}>
          <FormattedMessage id="onboarding.anonymous.alreadyHaveAnAccount" />
          &nbsp;
          <ExternalLink
            href={`${window.location.origin}/auth`}
            size={isXSmall ? 'small' : 'regular'}
            underline
            strong="semi-bold"
            className="u-color--neutral-600"
          >
            <FormattedMessage id="onboarding.anonymous.login.here" />
          </ExternalLink>
        </Text>
      </div>
    ),
    [isXSmall]
  )

  return (
    <SurveyLayout>
      <SurveyLandingPageLayout>
        <Title>
          <FormattedMessage id="onboarding.anonymous.title" />
        </Title>
        <div className="u-flex-align-center">
          <Text type="secondary">
            <FormattedMessage id="global.poweredBy" />
          </Text>
          <CommutifiLogo fill={styles.tealColor} className="u-margin-left--small" />
        </div>
        <SurveyLandingPageCardLayout style={{ marginTop: spacing.large3, maxWidth: '500px' }}>
          <>
            <Text>
              <FormattedMessage id="onboarding.anonymous.intro" />
            </Text>
            <CommutifiBenefit.Improve
              title={<FormattedMessage id="onboarding.anonymous.intro.improve.title" />}
              description={<FormattedMessage id="onboarding.anonymous.intro.improve.description" />}
            />
            <CommutifiBenefit.Understand
              description={<FormattedMessage id="onboarding.anonymous.intro.understand.description" />}
            />
            <CommutifiBenefit.SaveMoney
              description={<FormattedMessage id="onboarding.anonymous.intro.saveMoney.description" />}
            />
            <StartSurveyButtons
              className="u-margin-top--large-3 u-margin-bottom--small"
              startSurvey={handleStartAnonymousSurvey}
              startSurveyBtnText={
                <span>
                  <FormattedMessage id="onboarding.anonymous.button.startSurvey" />
                  {isXSmall ? renderAlreadyHaveAnAccount() : null}
                </span>
              }
              redirectToLogin={undefined}
            />
          </>
        </SurveyLandingPageCardLayout>
        {!isXSmall ? renderAlreadyHaveAnAccount() : null}
      </SurveyLandingPageLayout>
    </SurveyLayout>
  )
}

export default AnonymousLandingPage
